import React, { useEffect } from 'react';
import { NextPage } from 'next';

import { spaceActions } from 'store/space';
import { GetAllRetailsAPI, GetRegionsAPI } from 'api/space';
import { AxiosResponse } from 'axios';

import SubHeader from 'components/common/SubHeader';
import RetailListService from 'components/retail/_list';

import { SubHeaderOptions } from 'constants/index';
import { ERROR_500 } from 'constants/message';
import { useRouter } from 'next/router';

interface IProps {
  error?: boolean;
}

const RetailList: NextPage<IProps> = ({ error }: IProps) => {
  const router = useRouter();

  useEffect(() => {
    if (error) {
      alert(ERROR_500);
      router.push('/');
    }
  }, [error, router]);

  if (error) {
    return null;
  }

  return (
    <>
      <SubHeader options={SubHeaderOptions} selected="리테일" />
      <RetailListService />
    </>
  );
};

RetailList.getInitialProps = async ({ store }) => {
  const regions: AxiosResponse = await GetRegionsAPI();
  const retails: AxiosResponse = await GetAllRetailsAPI();

  if (regions.status >= 400 || retails.status >= 400) {
    return {
      error: true,
    };
  }

  store.dispatch(spaceActions.getRegions(regions.data));
  store.dispatch(spaceActions.getRetails(retails.data));

  return {
    error: false,
  };
};

export default RetailList;
